module.exports = __webpack_public_path__ + "img/event-img.b6b0ed7c.png";